module.exports = __webpack_public_path__ + "static/media/gift_annual_sub.56357851.png";